import { TextField, Grid, MenuItem, Typography, Chip } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import { useWatch } from "react-hook-form";


export default function VerfahrenMassnahmenForm() {
  const { control, setValue } = useFormContext();

  const vernichtungsIntervalle = ["monatlich", "halbjährlich", "jährlich"];

  const ablageOrteOptions = [
    "Posteingangskorb Sekretariat",
    "Ablagefach Buchhaltung",
    "Ablageordner Eingangsrechnungen im Büro Verwaltung",
    "Abschließbarer Schrank Buchhaltung",
  ];

  const ablageDigitalOptions = [
    "DMS (Dokumentenmanagementsystem)",
    "ERP-System (integriert mit Belegarchiv)",
    "Fibu-Software mit integriertem Belegarchiv",
    "Netzlaufwerk mit Zugriffskontrolle",
    "Cloud-Speicher mit Compliance-Funktionen",
    "Zertifiziertes Archivsystem (gemäß GoBD)",
    "Spezieller Server mit Zugriffskontrolle und Backup",
    "Cloud-DMS"
  ];
  
  const hilfsmittelOptions = [
    "Ordner",
    "Mappen",
    "Trennblätter",
    "Ablagekörbe",
    "abschließbarer Schrank",
  ];

  const sachlicheOrdnungsOptions = [
    "Eingangsrechnungen",
    "Ausgangsrechnungen",
    "bezahlt/unbezahlt",
    "Kassenbuch (bar/unbar)",
    "Warenein- und -ausgangsbelege",
    "Anschaffung Anlagevermögen",
    "Chronologisch nach Datum",
  ];

  const zeitlicheOrdnungsOptions = [
    "nach Wirtschaftsjahren",
    "nach Kalenderjahren",
    "nach Quartalen",
    "nach Monaten",
    "nach Wochen",
  ];

  const datenschutzMassnahmenOptions = [
    "Aufbewahrung in abschließbarem Schrank",
    "Zugang nur durch berechtigte Personen",
    "Schlüsselzugang",
    "geschützter Raum (z.B. Brand-/Diebstahlschutz)",
  ];

  const verknuepfungOptions = [
    "Ordnungsnummer im Buchungstext oder gesondertes Feld",
    "automatisch oder manuell vergebener Index (z.B. Barcode)",
    "Eigen- oder Fremdbelegnummer i.V.m. Personenkonto",
    "Referenznummer aus ERP-System",
    "Verlinkung über digitales Dokumentenmanagementsystem (DMS)",
  ];

  const weitergabeOptions = [
    "Weitergabe an Steuerberater zur Verbuchung",
    "Weitergabe an externe Buchhaltungsdienstleister",
    "Interne Weitergabe an Buchhaltung/Verwaltung",
    "Rückgabe durch Steuerberater nach Abschluss der Buchführung",
    "Transport durch persönlichen Kurier mit Empfangsbestätigung",
    "Transport durch Bote/Kurierdienst",
    "Transport durch versicherten Postversand",
    "Transport in versiegelten Umschlägen/Behältern",
    "Übergabe nur an autorisierte Personen",
    "Transport mit schriftlicher Empfangsbestätigung",
    "Kontrolle durch jährliche Prüfprotokolle der Kanzlei",
    "Verarbeitung nach vertraglicher Vereinbarung (z.B. AVV)",
    "Archivierung beim Steuerberater mit Datenschutzerklärung"
  ];

  const archivOrtOptions = [
    "Abschließbarer Schrank Buchhaltung",
    "Abgeschlossener Archivraum",
    "Archivschrank mit Zugangskontrolle im Büro Verwaltung",
    "Externe Lagerstelle (Aktenlager) mit Vertrag",
  ];

  const archivZugriffOptions = [
    "Zugriff ausschließlich Buchhaltungsleitung",
    "Zugriff Buchhaltung und Steuerberater",
    "Zugriff nur Geschäftsführung",
    "Zugriff nach Freigabe durch Compliance",
  ];

  const [selectedHilfsmittel, setSelectedHilfsmittel] = useState([]);
  const [selectedSachliche, setSelectedSachliche] = useState([]);
  const [selectedZeitliche, setSelectedZeitliche] = useState([]);
  const [selectedDatenschutz, setSelectedDatenschutz] = useState([]);
  const [selectedVerknuepfung, setSelectedVerknuepfung] = useState([]);
  const [selectedWeitergabe, setSelectedWeitergabe] = useState([]);
  const [selectedArchivOrt, setSelectedArchivOrt] = useState([]);
  const [selectedArchivZugriff, setSelectedArchivZugriff] = useState([]);
  const [selectedArchivSachliche, setSelectedArchivSachliche] = useState([]);
  const [selectedArchivZeitliche, setSelectedArchivZeitliche] = useState([]);
  const { getValues } = useFormContext();

useEffect(() => {
  const initial = getValues("ablageOrteHilfsmittel");
  if (initial) setSelectedHilfsmittel(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("ordnungssystemSachlich");
  if (initial) setSelectedSachliche(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("ordnungssystemZeitlich");
  if (initial) setSelectedZeitliche(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("sicherungPapierbelege");
  if (initial) setSelectedDatenschutz(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("aufbereitungBelege");
  if (initial) setSelectedVerknuepfung(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("weitergabeBelege");
  if (initial) setSelectedWeitergabe(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("archivOrt");
  if (initial) setSelectedArchivOrt(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("archivZugriff");
  if (initial) setSelectedArchivZugriff(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("archivSachlich");
  if (initial) setSelectedArchivSachliche(initial.split(", ").filter(Boolean));
}, []);

useEffect(() => {
  const initial = getValues("archivZeitlich");
  if (initial) setSelectedArchivZeitliche(initial.split(", ").filter(Boolean));
}, []);


  const toggleChip = (item, selectedItems, setSelectedItems, fieldName) => {
    let updated;
    if (selectedItems.includes(item)) {
      updated = selectedItems.filter((i) => i !== item);
    } else {
      updated = [...selectedItems, item];
    }
    setSelectedItems(updated);
    setValue(fieldName, updated.join(", "));
  };

  const Beschriftung = ({ children }) => (
    <Typography variant="subtitle2" gutterBottom>{children}</Typography>
  );

  return (
    <Grid container spacing={3} direction="column">
             <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
             Ablage, Sicherung und Archivierung von Papier- und Digitalbelegen                    </Typography>

            <Typography variant="h6" gutterBottom>Belege in Papierform</Typography>

      {/* Papierhafte Eingangspost */}
      <Grid item xs={12}>
        <Beschriftung>Wählen oder ergänzen Sie hier, wo die papierhafte Eingangspost aufbewahrt wird.</Beschriftung>
        <Controller
          name="papierPosteingangOrt"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Ablageort papierhafte Eingangspost" select fullWidth>
              {ablageOrteOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>
      {/* Identifizierte Belege */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie den Ablageort der identifizierten Belege.</Beschriftung>
        <Controller
          name="identifizierteBelegeOrt"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Ablageort identifizierter Belege" select fullWidth>
              {ablageOrteOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Ablagehilfsmittel */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die eingesetzten Ablagehilfsmittel:</Beschriftung>
        <Grid container spacing={1}>
          {hilfsmittelOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedHilfsmittel.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedHilfsmittel, setSelectedHilfsmittel, "ablageOrteHilfsmittel")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Sachliche Ordnung */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die sachliche Ordnung der Belege:</Beschriftung>
        <Grid container spacing={1}>
          {sachlicheOrdnungsOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedSachliche.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedSachliche, setSelectedSachliche, "ordnungssystemSachlich")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Zeitliche Ordnung */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die zeitliche Ordnung der Belege:</Beschriftung>
        <Grid container spacing={1}>
          {zeitlicheOrdnungsOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedZeitliche.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedZeitliche, setSelectedZeitliche, "ordnungssystemZeitlich")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Turnus Belegsicherung */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie hier den Turnus der Belegsicherung:</Beschriftung>
        <Controller
          name="belegsicherungTurnus"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Turnus Belegsicherung" select fullWidth>
              {["täglich", "wöchentlich", "monatlich", "quartalsweise", "jährlich"].map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      {/* Maßnahmen Papierbelege */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie Maßnahmen zur Sicherung der Papierbelege:</Beschriftung>
        <Grid container spacing={1}>
          {datenschutzMassnahmenOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedDatenschutz.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedDatenschutz, setSelectedDatenschutz, "sicherungPapierbelege")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Technische/logische Verknüpfung */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die technische/logische Verknüpfung des Belegs mit dem Buchungssatz:</Beschriftung>
        <Grid container spacing={1}>
          {verknuepfungOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedVerknuepfung.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedVerknuepfung, setSelectedVerknuepfung, "aufbereitungBelege")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Weitergabe */}
      <Grid item xs={12}>
        <Beschriftung>Wählen oder ergänzen Sie die zutreffenden Regelungen zur Weitergabe/Rücknahme von Belegen:</Beschriftung>
        <Grid container spacing={1}>
          {weitergabeOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedWeitergabe.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedWeitergabe, setSelectedWeitergabe, "weitergabeBelege")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Archivsystem - Ort */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie den Ort der Archivierung:</Beschriftung>
        <Grid container spacing={1}>
          {archivOrtOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedArchivOrt.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedArchivOrt, setSelectedArchivOrt, "archivOrt")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Archivsystem - Zugriff */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die Zugriffsberechtigten für das Archiv:</Beschriftung>
        <Grid container spacing={1}>
          {archivZugriffOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedArchivZugriff.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedArchivZugriff, setSelectedArchivZugriff, "archivZugriff")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Archivsystem - Sachliche Ordnung */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die sachliche Ordnung der archivierten Belege:</Beschriftung>
        <Grid container spacing={1}>
          {sachlicheOrdnungsOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedArchivSachliche.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedArchivSachliche, setSelectedArchivSachliche, "archivSachlich")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Archivsystem - Zeitliche Ordnung */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie die zeitliche Ordnung der archivierten Belege:</Beschriftung>
        <Grid container spacing={1}>
          {zeitlicheOrdnungsOptions.map((item) => (
            <Grid item key={item}>
              <Chip
                label={item}
                clickable
                color={selectedArchivZeitliche.includes(item) ? "primary" : "default"}
                onClick={() =>
                  toggleChip(item, selectedArchivZeitliche, setSelectedArchivZeitliche, "archivZeitlich")
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Vernichtungsintervall */}
      <Grid item xs={12}>
        <Beschriftung>Wählen Sie das Vernichtungsintervall der Belege:</Beschriftung>
        <Controller
          name="vernichtungsintervall"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Vernichtungsintervall" select fullWidth>
              {vernichtungsIntervalle.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      <Grid container spacing={3} direction="column">
      <Typography variant="h6" gutterBottom>Digitale Belege</Typography>

      {/* Digitale Eingangspost */}
      <Grid item xs={12}>
        <Beschriftung>Wählen oder ergänzen Sie hier, wo die digitale Belege aufbewahrt werden.</Beschriftung>
        <Controller
          name="digitalPosteingangOrt"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Ablageort digitale Belege" select fullWidth>
              {ablageDigitalOptions.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>
      <Grid item xs={12}>
    <Beschriftung>Bitte geben Sie hier an, in welchem Verzeichnis oder in welcher Software die digitalen Belege gespeichert werden.</Beschriftung>
    <Controller
      name="digitalPosteingangOrtCustom"
      control={control}
      render={({ field }) => (
        <TextField {...field} label="Eigenes Verzeichnis / Software" placeholder="z.B. S:\\Buchhaltung\\2025\\Eingangsrechnungen oder DocuWare" fullWidth />
      )}
    />
  </Grid>

      {/* Übergabe an Steuerberater */}
      <Grid item xs={12}>
        <Beschriftung>Beschreiben Sie, wie Belege an den Steuerberater übergeben werden:</Beschriftung>
        <Controller
          name="uebergabeSteuerberater"
          control={control}
          render={({ field }) => (
            <TextField 
              {...field} 
              label="Übergabe an Steuerberater" 
              multiline
              rows={3}
              fullWidth
              placeholder="z.B. Hochladen in Steuerberater-Cloud, per Post, persönliche Übergabe, E-Mail, etc."
            />
          )}
        />
      </Grid>

      </Grid>
    </Grid>
    
  );
}
